import React from "react";
import { useState } from "react";
import { useWorkoutsContext } from "../../../Hook/contextHooks/useWorkoutsContext";
import { useAuthContext } from "../../../Hook/contextHooks/useAuthContext";
import { BASE_URL } from "../../../globalClasses/Config";

const WorkoutForm = () => {
  const { user } = useAuthContext();
  const { dispatch } = useWorkoutsContext();
  const [title, setTitle] = useState("");
  const [load, setLoad] = useState("");
  const [reps, setReps] = useState("");
  const [error, setError] = useState(null);
  const [emptyFields, setEmptyFields] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user) {
      setError("You must be logged in...");
      return;
    }

    const workout = { title, load, reps };

    const response = await fetch(`${BASE_URL}/api/workouts/`, {
      method: "POST",
      body: JSON.stringify(workout),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
    });

    const json = await response.json();

    if (!response.ok) {
      setError(json.error);
      setEmptyFields(json.emptyFields);
    }

    if (response.ok) {
      setTitle("");
      setLoad("");
      setReps("");
      setError(null);
      setEmptyFields([]);
      dispatch({ type: "CREATE_WORKOUT", payload: json });
      console.log("New Workout Added", json);
    }
  };

  return (
    <form className="workoutForm" onSubmit={handleSubmit}>
      <h3>Add a new Teacher</h3>
      <label>Teacher name</label>
      <input
        type="text"
        onChange={(e) => setTitle(e.target.value)}
        value={title}
        className={emptyFields.includes("title") ? "error" : ""}
      />
      <label>Id</label>
      <input
        type="number"
        onChange={(e) => setLoad(e.target.value)}
        value={load}
        className={emptyFields.includes("load") ? "error" : ""}
      />
      <label>Phone no:</label>
      <input
        type="number"
        onChange={(e) => setReps(e.target.value)}
        value={reps}
        className={emptyFields.includes("reps") ? "error" : ""}
      />
      <button className="workoutButton">Add Teacher</button>
      {error && <div className="workoutError">{error}</div>}
    </form>
  );
};

export default WorkoutForm;
